module.exports = __webpack_public_path__ + "static/media/receiving_request_id.87fb8437.jpg";